import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import { getAgencies } from '../../actions/agency';
// import SelectedUserSideBar from './selected-users';
import TableFilter from './TableFilter';
import RecordTable from './RecordTable';

class AgentCallRecords extends React.PureComponent {
  componentDidMount() {
    const { filter } = this.props;

    filter('');
    getAgencies();
  }

  componentWillUnmount() {
    const {
      clearRecordList,
      clearSearchTerm,
      resetDescSort,
      clearSelectedAgents,
      setAgencyFilter,
      setInitialSelect,
    } = this.props;

    clearRecordList();
    clearSearchTerm();
    resetDescSort();
    clearSelectedAgents();
    setAgencyFilter('');
    setInitialSelect(true);
  }

  render() {
    return (
      <>
        {/* <SelectedUserSideBar /> */}
        <main
          className="p-5"
          style={{
            /* Exact height for proper in-table scrolling */
            /* Based on page header being 3rem */
            maxHeight: 'calc(100vh - 3rem)',
            minHeight: 'calc(100vh - 3rem)',
            overflow: 'hidden',
          }}
        >
          <Row>
            <Col className="w-auto">
              <h2 className="mb-3 font-weight-bold">
                Agent Call Records
              </h2>
            </Col>
          </Row>
          <Row>
            <div className="w-auto" style={{ overflow: 'hidden' }}>
              <div className="border bg-white h-100 shadow-sm">
                <TableFilter />
                <RecordTable />
              </div>
            </div>
          </Row>
        </main>
      </>
    );
  }
}

const mapStateToProps = (store) => ({
  recordPage: store.records.recordPage,
  selectedAgents: store.records.selectedAgents,
});

const mapDispatchToProps = {
  filter: (term) => ({ type: 'FILTER', term }),
  clearRecordList: () => ({ type: 'CLEAR_RECORD_LIST' }),
  clearSearchTerm: () => ({ type: 'CLEAR_SEARCH_TERM' }),
  resetDescSort: () => ({ type: 'RESET_DESC_SORT' }),
  clearSelectedAgents: () => ({ type: 'CLEAR_SELECTED_AGENTS' }),
  setAgencyFilter: (payload) => ({ type: 'SET_AGENCY_FILTER', payload }),
  setInitialSelect: (payload) => ({ type: 'SET_INITIAL_SELECT', payload }),
  setAllSelectCheckbox: (payload) => ({ type: 'SET_ALL_SELECT_CHECKBOX', payload }),
};

export default connect(mapStateToProps, mapDispatchToProps)(AgentCallRecords);
